"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var platform_browser_1 = require("@angular/platform-browser");
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var flex_layout_1 = require("@angular/flex-layout");
var authentication_service_1 = require("../authentication/authentication.service");
var i18n_service_1 = require("../i18n.service");
var material_1 = require("@angular/material");
require("./shell.component.scss");
var ShellComponent = /** @class */ (function () {
    function ShellComponent(router, titleService, media, authenticationService, i18nService) {
        this.router = router;
        this.titleService = titleService;
        this.media = media;
        this.authenticationService = authenticationService;
        this.i18nService = i18nService;
    }
    Object.defineProperty(ShellComponent.prototype, "username", {
        get: function () {
            var credentials = this.authenticationService.credentials;
            return credentials ? credentials.username : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShellComponent.prototype, "canSeePatientSelection", {
        get: function () {
            return this.authenticationService.hasRole("physician" /* PHYSICIAN */, "service_engineer" /* SERVICE_ENGINEER */, "admin" /* ADMIN */);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShellComponent.prototype, "canSeeUserAdministration", {
        get: function () {
            return this.authenticationService.hasRole("service_engineer" /* SERVICE_ENGINEER */, "admin" /* ADMIN */);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShellComponent.prototype, "languages", {
        get: function () {
            return this.i18nService.supportedLanguages;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShellComponent.prototype, "isMobile", {
        get: function () {
            return this.media.isActive('xs') || this.media.isActive('sm');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShellComponent.prototype, "title", {
        get: function () {
            return this.titleService.getTitle();
        },
        enumerable: true,
        configurable: true
    });
    ShellComponent.prototype.ngOnInit = function () {
    };
    ShellComponent.prototype.setLanguage = function (language) {
        this.i18nService.language = language;
        location.reload();
    };
    ShellComponent.prototype.logout = function () {
        this.authenticationService.logout();
        this.router.navigate(['/login'], { replaceUrl: true });
    };
    ShellComponent.prototype.closeSidebar = function () {
        if (this.isMobile) {
            this.sidebar.close();
        }
    };
    tslib_1.__decorate([
        core_1.ViewChild('sidenav'),
        tslib_1.__metadata("design:type", material_1.MatSidenav)
    ], ShellComponent.prototype, "sidebar", void 0);
    ShellComponent = tslib_1.__decorate([
        core_1.Component({
            selector: 'app-shell',
            template: require('./shell.component.html')
        }),
        tslib_1.__metadata("design:paramtypes", [router_1.Router,
            platform_browser_1.Title,
            flex_layout_1.ObservableMedia,
            authentication_service_1.AuthenticationService,
            i18n_service_1.I18nService])
    ], ShellComponent);
    return ShellComponent;
}());
exports.ShellComponent = ShellComponent;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/app/core/shell/shell.component.ts
// module id = 269
// module chunks = 0